// =====================================================================
// Asse di rilascio a 3 stadi, condiviso da backend, economic-engine e
// frontend_mobile per il rollout selettivo di una feature.
//
//   off   → nessuno (kill-switch / comportamento legacy)
//   admin → solo gli utenti isAdmin (canary in produzione)
//   all   → tutti (GA)
//
// Reintrodotto per HOSTED_PAYMENTS (pagamento wallet/hosted): i vecchi
// ROLLOUT_* di notifiche e pre-auth sono stati rimossi quando quelle feature
// sono andate GA — questo file resta il posto dove vive la semantica.
// =====================================================================

export type ReleaseStage = 'off' | 'admin' | 'all';

/**
 * Decide se un utente rientra nell'audience dello stadio corrente.
 * `isAdmin` undefined (es. evento legacy senza il campo) → trattato come
 * NON-admin: in stage 'admin' resta fuori (scelta safe).
 */
export function inAudience(stage: ReleaseStage, isAdmin: boolean | undefined | null): boolean {
  return stage === 'all' || (stage === 'admin' && isAdmin === true);
}

/** Normalizza un valore libero da runtime_config: tutto ciò che non è admin/all è off. */
export function toReleaseStage(raw: string | undefined | null): ReleaseStage {
  return raw === 'admin' || raw === 'all' ? raw : 'off';
}
